var mql = window.matchMedia("only screen and (max-width: " + mobileBreakPoint + ")");
mediaqueryresponse(mql);
mql.addEventListener('change', mediaqueryresponse);

function mediaqueryresponse(mql) {
  if (mql.matches) {
    // Mobile JS
    uspSlider();
  }
}

function uspSlider() {
  var announcementBar = document.querySelector('#announcement-bar__usps');

  if (matchMedia("only screen and (max-width: " + mobileBreakPoint + ")").matches) {
    if (announcementBar) {
      var items = announcementBar.querySelectorAll('.announcement-bar__item-usp');
      var i = 0;
      len = items.length;
      items[0].classList.add('active');
      setInterval(function () {
        items.forEach(function (item) {
          item.classList.remove('active');
        });
        items[i].classList.add('active');
        i = (i + 1) % len;
      }, 5000);
    }
  }
}
